<template>
  <div class="wrapperdtsyn">
    <div class="top-wrapper" @click="knowDTAction" >
      <div class="top-tip-text">按照每月1号定投进行计算。</div>
      <div class="top-tip-textleft">了解定投
        <img src="@/assets/right-arrow-gray.png"
          alt=""
          class="right-arrow"/>
      </div>
    </div>
    <div class="single top ">
      <span class="period">周期</span>
      <span class="syl"></span>
      <span class="syl"></span>
      <span class="syl"></span>
      <span class="rank">普通定投</span>
    </div>
    <div class="single bottom ">
      <span class="period">近1年</span>
      <span class="syl"></span>
      <span class="syl"></span>
      <span class="syl"></span>
      <span :class="['rank', `${upDown(pageData.PTDT_Y)}`]"
      >{{`${getCurValue(pageData.PTDT_Y)}`}}</span>
    </div>
     <div class="single bottom ">
      <span class="period">近2年</span>
      <span class="syl"></span>
      <span class="syl"></span>
      <span class="syl"></span>
      <span :class="['rank', `${upDown(pageData.PTDT_TWY)}`]"
      >{{`${getCurValue(pageData.PTDT_TWY)}`}}</span>
    </div>
     <div class="single bottom ">
      <span class="period">近3年</span>
      <span class="syl"></span>
      <span class="syl"></span>
      <span class="syl"></span>
      <span :class="['rank', `${upDown(pageData.PTDT_TRY)}`]"
      >{{`${getCurValue(pageData.PTDT_TRY)}`}}</span>
    </div>
     <div class="single bottom">
      <span class="period">近5年</span>
      <span class="syl"></span>
      <span class="syl"></span>
      <span class="syl"></span>
      <span :class="['rank', `${upDown(pageData.PTDT_FY)}`]"
      >{{`${getCurValue(pageData.PTDT_FY)}`}}</span>
    </div>
  </div>
</template>

<style lang="less" scoped>
.wrapperdtsyn {
  background-color: white;
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 12px;
}
.single {
  font-family: DINAlternate-Bold;
  display: flex;
  font-size: 28px;
  align-items: center;
  justify-content: space-between;
  height: 90px;
}
.gray {
  color: #999999;
}
.red {
  color: @app-color-up;
}
.green {
  color: @app-color-down;
}
.top {
  color: #999999;
  font-family: PingFangSC-Regular;
  .period {
    font-family: PingFangSC-Regular;
    text-align: left;
    width: 27%;
  }
  .syl {
    text-align: center;

  white-space:nowrap;
    width: 27%;
  }
  .avg {
    text-align: center;
    width: 26%;
  }
  .rank {
    text-align: right;
    width: 35%;
  }
}
.bottom {
  font-size: 32px;
  .period {
    font-size: 30px;
    font-family: PingFangSC-Regular;
    text-align: left;
    width: 27%;
  }
  .syl {
    // text-align: left;
    // background-color: orange;
    text-align: right;
    width: 27%;
  }
  .avg {
    // background-color: cyan;
    padding: 10px 0px;
    text-align: center;
    width: 26%;
  }
  .rank {
    text-align: right;
    width: 35%;
  }
  .rank-wrap {
    padding: 10px 0px;
    text-align: right;
    flex-shrink: 0;
    margin-right: 30px;
    .rank {
      color: black;
    }
    .sc {
      color: #666666;
    }
  }
}
.more-wrapper {
  background-color: #ffffff;
  padding: 30px;
}

.more-text {
  font-size: 30px;
  color: #008aff;
  text-align: center;
  line-height: 30px;
}
.top-wrapper {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 90px;
  padding-left: 24px;
  padding-right: 14px;
  background: #F5F5F5;
  border-radius: 8px;
}
.top-tip-text {
  font-size: 30px;
  color: #666666;
}
.top-tip-textleft {
  font-size: 30px;
  color: #666666;
  display: flex;
  align-items: center;
}
.right-arrow {
    width: 32px;
    height: 32px;
  }
</style>

<script>

import StoreManger from '@/utils/FundHQJHManger';
import {
  detailPushPage,
} from '@/utils/nativeBridge';

export default {
  name: 'mark-period-increase',
  props: {},
  watch: {},
  components: {
  },
  data() {
    return {
      pageData: {},
      fundCode: '',
      fundType: '',
      bfundType: '',
    };
  },
  computed: {},
  created() {
    this.fundCode = this.$store.state.native.fund.fundCode;
    this.fundType = this.$store.state.native.fund.fundType;
    const fundinfo = StoreManger.getFundJJXQ();

    this.pageData = fundinfo;
  },
  mounted() {},
  methods: {
    render() {
    },
    knowDTAction() {
      // 了解定投
      const zdLink = { LinkType: '2', LinkTo: 'fund://mp.1234567.com.cn/weex/6f5a3debe5b44f5da7aacb7c58957bc3?message=定投是什么？' };
      detailPushPage({
        type: zdLink.LinkType,
        url: zdLink.LinkTo,
      });
    },
    handleDefault() {

    },
    getCurValue(value) {
      if (value === '--') {
        return '--';
      }
      return `${parseFloat(value).toFixed(2)}%`;
    },
    clickKnowDt() {
      const znzlLink = { LinkType: '2', LinkTo: 'fund://mp.1234567.com.cn/weex/6f5a3debe5b44f5da7aacb7c58957bc3?message=定投是什么？' };
      const { LinkType, LinkTo } = znzlLink;
      detailPushPage({
        type: LinkType,
        url: LinkTo,
      });
    },
    upDown(value) {
      const newV = parseFloat(value);
      if (newV > 0) {
        return 'red';
      }
      if (newV < 0) {
        return 'green';
      }
      return 'gray';
    },
  },
};
</script>
